import { GuaranteeTypeEnum } from '@insurance/api/requests'
import { Divider, Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { FixedBeneficiary } from './FixedBeneficiary'
import { formProps, hasFixedBeneficiary } from './utils'
import { ContractorTypeFields } from '../PersonsFields'

export const PartiesStep = () => {
  const { t } = useTranslation()
  const { guaranteeTypeProps, contractorProps, beneficiaryProps } = formProps(t)

  const guaranteeType = Form.useWatch<GuaranteeTypeEnum>(
    guaranteeTypeProps.name,
    { preserve: true }
  )

  const isFixedBeneficiary = hasFixedBeneficiary(guaranteeType)

  return (
    <>
      <ContractorTypeFields
        title={contractorProps.label}
        contractorKey={contractorProps.name}
        showSameContractorField={false}
        resident
      />

      <Divider />

      {isFixedBeneficiary ? (
        <FixedBeneficiary guaranteeType={guaranteeType} />
      ) : (
        <ContractorTypeFields
          title={beneficiaryProps.label}
          contractorKey={beneficiaryProps.name}
          locationTitle={t('beneficiary_domicile')}
          addButtonTitle={t('add_existing_beneficiary')}
          showSameContractorField={false}
          resident
        />
      )}
    </>
  )
}
